import { render } from "./SpinIcon.vue?vue&type=template&id=67996305"
import script from "./SpinIcon.vue?vue&type=script&lang=js"
export * from "./SpinIcon.vue?vue&type=script&lang=js"
script.render = render

export default script